import React from "react";
import { useSidebarContext } from "../global/sidebar/SidebarContext";

const Society_Map = () => {
  const { activeSociety, theme, gradient } = useSidebarContext();

  return (
    <div className={`min-h-screen ${gradient} py-8 px-4 sm:px-6 lg:px-8`}>
      <div className="max-w-7xl mx-auto">
        {/* Header Section */}
        <div className="mb-8">
          <h1
            className={`text-4xl md:text-5xl font-bold mb-3 text-transparent bg-clip-text ${theme.tailwind.bgr15}`}
          >
            Society Map
          </h1>
          <p className={`${theme.tailwind.texting2} text-lg`}>
            View the layout and location of plots in {activeSociety?.name || 'the society'}
          </p>
        </div>

        {/* Map Container */}
        <div
          className={`backdrop-blur-xl ${theme.tailwind.bg2} rounded-3xl p-6 md:p-8 shadow-2xl border ${theme.tailwind.border19} overflow-hidden`}
        >
          <div className="mb-6">
            <h2
              className={`text-2xl md:text-3xl font-bold ${theme.tailwind.text9} mb-2`}
            >
              {activeSociety?.name || 'Society'} Map View
            </h2>
            {activeSociety?.location && (
              <p className={`${theme.tailwind.texting2} text-sm md:text-base`}>
                📍 {activeSociety.location}
              </p>
            )}
          </div>

          <div className="relative overflow-hidden rounded-xl border border-white/10 bg-black/20">
            {activeSociety?.society_map_image ? (
              <div className="aspect-video flex items-center justify-center relative group">
                <img
                  src={activeSociety.society_map_image}
                  alt={`${activeSociety.name} Map`}
                  className="w-full h-full object-contain transition-transform duration-300 group-hover:scale-105 rounded-xl"
                  onContextMenu={(e) => e.preventDefault()}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-xl" />
                <div className="absolute bottom-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <button
                    onClick={() => window.open(activeSociety.society_map_image, '_blank')}
                    className={`${theme.tailwind.bg34} ${theme.tailwind.text9} px-4 py-2 rounded-lg text-sm font-medium backdrop-blur-sm border ${theme.tailwind.border2} hover:scale-105 transition-transform`}
                  >
                    View Full Size
                  </button>
                </div>
              </div>
            ) : (
              <div className="aspect-video flex flex-col items-center justify-center rounded-xl p-8">
                <div className={`${theme.tailwind.bg34} rounded-full p-6 mb-4`}>
                  <svg
                    className={`w-16 h-16 ${theme.tailwind.texting2}`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
                    />
                  </svg>
                </div>
                <p className={`${theme.tailwind.texting2} text-lg text-center max-w-md`}>
                  No map image available for {activeSociety?.name || 'this society'}.
                </p>
                <p className={`${theme.tailwind.texting2} text-sm text-center mt-2 opacity-70`}>
                  Please contact the administrator for map details.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Society_Map;
